<template>
    <v-layout align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
</template>

<script>
export default {

}
</script>